import useTranslator from "@hooks/use-translator";
import { Input } from "@components/common/input";
import { Button } from "@components/common/button";
import { PlusCircle } from "lucide-react";
import axios from "axios";
import { ADD_DEPARTMENT_ENDPOINT, SERVER_URL } from "@pma/utils/api-routes";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "@stores/auth-store";
import { parseCookies } from "nookies";
import { ACCESS_TOKEN } from "@pma/utils/constants";
import { useState } from "react";
import { DictType } from "@pma/types";
import { toast } from "@hooks/use-toast";

interface Props {
  refetch?: CallableFunction;
}
const AddDepartment = ({ refetch }: Props) => {
  const [departmentName, setDepartmentName] = useState("");
  const { translate, locale } = useTranslator();
  const { authConfig } = useAuth();

  const accessToken = parseCookies()[ACCESS_TOKEN];

  const orgId = authConfig?.last_organization_id;

  const addDepartment = async () => {
    const response = await axios.post(
      SERVER_URL + ADD_DEPARTMENT_ENDPOINT,
      {
        department: departmentName,
        organization_id: orgId,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return response.data;
  };

  const addDepartmentMutation = useMutation({
    mutationKey: ["add-department"],
    mutationFn: addDepartment,
    onSuccess: (data) => {
      setDepartmentName("");
      refetch && refetch();
    },
    onError: (error: DictType) => {
      toast({
        title: translate("Error"),
        description: error?.response?.data.message ||
                translate(`Error occurred while updating`) +
                  " " +
                  translate(`department`),
        variant: "error",
      });
    },
  });

  const onSubmit = (e: any) => {
    e.preventDefault();
    addDepartmentMutation.mutate();
  };

  return (
    <form onSubmit={onSubmit} className="flex items-center gap-2">
      <Input
        placeholder={translate("Add Department")}
        className="rounded-full"
        required
        value={departmentName}
        onChange={(e) => setDepartmentName(e.target.value)}
      />
      <Button size={"sm"} className="rounded-full h-7 w-7 m-0 p-0">
        <PlusCircle className=" h-7 w-7 rounded-full" />
      </Button>
    </form>
  );
};

export default AddDepartment;
